import makeSlice from '@web/slices/common/sliceMaker'

const slice = makeSlice()

export default slice.reducer
